import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PropTypes from "prop-types";
import Ticket from "../ticket/Ticket";
import "./sortableTicket.scss";

function SortableTicket({ ticket, editable, deletable, handleDelete, handleEdit }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: ticket.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`sortableTicketWrapper ${isDragging ? "isDragging" : ""}`}
      {...attributes}
      {...listeners}
    >
      <Ticket
        ticket={ticket}
        editable={editable}
        deletable={deletable}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
    </div>
  );
}

SortableTicket.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    numAvailable: PropTypes.number.isRequired,
    amountSold: PropTypes.number.isRequired,
  }).isRequired,
  editable: PropTypes.bool,
  deletable: PropTypes.bool,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
};

export default SortableTicket;
